import React from 'react';
import { motion } from 'framer-motion';
import { Folder, Trash2, Calendar, DollarSign } from 'lucide-react';
import { useBudgetStore, SavedBudget } from '../store/budgetStore';
import toast from 'react-hot-toast';

interface SavedBudgetsProps {
  onLoadBudget: (budget: SavedBudget) => void;
}

export const SavedBudgets: React.FC<SavedBudgetsProps> = ({ onLoadBudget }) => {
  const savedBudgets = useBudgetStore(state => state.savedBudgets);
  const deleteBudget = useBudgetStore(state => state.deleteBudget);

  const handleDelete = (id: string) => {
    if (confirm('Are you sure you want to delete this budget?')) {
      deleteBudget(id);
      toast.success('Budget deleted successfully');
    }
  };

  if (savedBudgets.length === 0) {
    return (
      <div className="text-center py-8 text-slate-400">
        <Folder className="w-12 h-12 mx-auto mb-3 opacity-50" />
        <p>No saved budgets yet. Create and save a budget to see it here.</p>
      </div>
    );
  }

  return (
    <div className="space-y-4">
      {savedBudgets.map((budget) => (
        <motion.div
          key={budget.id}
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          className="glass-card p-4 hover:bg-slate-800/30 transition-colors"
        >
          <div className="flex items-center justify-between">
            <div>
              <h3 className="font-medium mb-1">{budget.name}</h3>
              <div className="flex items-center gap-4 text-sm text-slate-400">
                <div className="flex items-center gap-1">
                  <Calendar className="w-4 h-4" />
                  {new Date(budget.createdAt).toLocaleDateString()}
                </div>
                <div className="flex items-center gap-1">
                  <DollarSign className="w-4 h-4" />
                  ${budget.income.toLocaleString()}
                </div>
              </div>
            </div>
            <div className="flex items-center gap-2">
              <button
                onClick={() => onLoadBudget(budget)}
                className="px-4 py-2 bg-emerald-500/10 text-emerald-500 rounded-lg hover:bg-emerald-500/20 transition-colors"
              >
                Load
              </button>
              <button
                onClick={() => handleDelete(budget.id)}
                className="p-2 text-red-500 hover:bg-red-500/10 rounded-lg transition-colors"
              >
                <Trash2 className="w-4 h-4" />
              </button>
            </div>
          </div>
        </motion.div>
      ))}
    </div>
  );
};